import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FileDashboardComponent } from './file-dashboard/file-dashboard.component';
import { FileManagerComponent } from './file-manager.component';
import { InboxComponent } from './inbox/inbox.component';
import { StarredComponent } from './starred/starred.component';
import { TrashComponent } from './trash/trash.component';


const routes: Routes = [
  {
    path: '',
    component: FileManagerComponent,
    children: [
      {
        path: '',
        component: FileDashboardComponent
      },
      {
        path: 'inbox',
        component: InboxComponent
      },
      {
        path: 'starred',
        component: StarredComponent
      },
      {
        path: 'trash',
        component: TrashComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class fileManagerRoutingModule { }
